import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { LargeButton, ButtonType, Button } from '@checkmarx/cx-ui';


const MainPortalWrapper = require('./components/portal/mainPortalWrapper').default;

LargeButton.defaultProps = {
	buttonType: ButtonType.blue
};
Button.defaultProps = {
	buttonType: ButtonType.blue
};

ReactDOM.render(<AppContainer><MainPortalWrapper /></AppContainer>, document.getElementById("root"));
